// frontend/src/index.js

import React from "react";
import ReactDOM from "react-dom/client";
import { ThemeProvider as MuiThemeProvider, CssBaseline } from "@mui/material";
import theme from "./design/theme";
import "./design/design.css";

const App = process.env.REACT_APP_CLIENT_APP === 'true'
  ? require('./mobile/ClientApp').default
  : require('./App').default;

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <MuiThemeProvider theme={theme}><CssBaseline /><App /></MuiThemeProvider>
  </React.StrictMode>
);
